export default "__VITE_ASSET__32d5ac4f__"